// Lightweight money formatter used across the promo panel.
// (The 5-tier VIP program has been fully removed at the user's request.)
export function fmtBDT(n) {
  return Number(n || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
